import { ERROR_CATALOG } from "@/lib/errors";

// The "Mark an Identified Error" icon grid, matching the real app screen.
// onPick(error) makes each tile tappable (used in the interactive demo).
export function ErrorIconGrid({ onPick, interactive = false }) {
  return (
    <div className="grid grid-cols-4 gap-2">
      {ERROR_CATALOG.map((e) => {
        const Cmp = interactive ? "button" : "div";
        return (
          <Cmp
            key={e.code}
            onClick={interactive ? () => onPick?.(e) : undefined}
            data-testid={interactive ? `demo-error-${e.code}` : undefined}
            className={`flex flex-col items-center rounded-2xl bg-[#F4F5F6] px-1 py-3 text-center ${
              interactive ? "transition-transform active:scale-95 hover:bg-[#ECEEF0]" : ""
            }`}
          >
            <span
              className="grid place-items-center w-[46px] h-[46px] rounded-full text-white"
              style={{ background: e.color }}
            >
              <e.Icon size={22} strokeWidth={2.4} />
            </span>
            <span className="mt-2 text-[11px] font-extrabold tracking-tight text-[#1a1a1a] leading-none">{e.code}</span>
            <span className="mt-1 text-[8.5px] leading-[1.15] text-[#2B2B2B]/55 px-0.5">{e.label}</span>
          </Cmp>
        );
      })}
    </div>
  );
}
